(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/api/jupiter/vouchers/services/payment-errors.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/api/jupiter/vouchers/services/payment-errors.js');
'use strict';

class PaymentError extends svs.tur.payment.services.PaymentError {
  getErrorData() {
    return {
      errorType: this.errorCode,
      origError: this.response
    };
  }

  showErrorDialog(onConfirm) {
    const {
      ERROR_BAD_RECEIEVER,
      ERROR_INVALID_VOUCHER_ID,
      ERROR_INVALID_PARAM,
      ERROR_INVALID_COUNT,
      ERROR_INVALID_DELIVERY_DATE,
      ERROR_CRITICAL,
      ERROR_USER_SUSPENDED,
      ERROR_ACCOUNT_LOW,
      ERROR_DEPOSIT_BUDGET_NOT_SET
    } = svs.tur.payment.api.jupiter.vouchers.utils.constants.apierrors;
    switch (this.errorCode) {
      case ERROR_USER_SUSPENDED:
        this.showAccountSuspendedDialog();
        break;
      case ERROR_ACCOUNT_LOW:
        this.showAccountLowFundsDialog({});
        break;
      case ERROR_CRITICAL:
        this.showCriticalError();
        break;
      case ERROR_BAD_RECEIEVER:
        this.showVoucherError('Hoppsan! Något med mottagaruppgiften är fel. Kontrollera och försök igen.');
        break;
      case ERROR_INVALID_VOUCHER_ID:
        this.showVoucherError('Hoppsan! Något gick fel. Vänligen försök igen om en stund.');
        break;
      case ERROR_INVALID_PARAM:
        this.showVoucherError('Det finns ogiltiga tecken i uppgifterna. Kontrollera och försök igen.');
        break;
      case ERROR_INVALID_COUNT:
        this.showVoucherError('Du kan max ge bort 10 st lotter totalt. Kontrollera antalet lotter och försök igen.');
        break;
      case ERROR_INVALID_DELIVERY_DATE:
        this.showVoucherError('Du måste ange ett datum i formatet åååå-mm-dd och en tid i formatet hh:mm. Datumet måste vara mellan idag och 1 år framåt.');
        break;
      case ERROR_DEPOSIT_BUDGET_NOT_SET:
        svs.tur.apierrors.showErrorMessage({
          response: 6289
        });
        break;
      default:
        svs.tur.apierrors.showErrorMessage({
          response: this.response,
          onConfirm: () => {
            onConfirm && onConfirm();
          }
        });
        break;
    }
  }
  showVoucherError(errorMessage) {
    new svs.tur.payment.dialogs.PaymentError({
      errorTitle: 'Fel',
      errorMessage
    });
  }
  showCriticalError() {
    const messageParts = decodeURI(this.response.error.message).split(' ');
    const boughtVouchers = parseInt(messageParts[0], 10);
    const totalVouchers = parseInt(messageParts[1], 10);
    let numberOfVouchers = 'Inte alla';
    if (!isNaN(boughtVouchers) && !isNaN(totalVouchers)) {
      numberOfVouchers = "".concat(boughtVouchers, " av ").concat(totalVouchers);
    }
    new svs.tur.payment.dialogs.PaymentError({
      errorTitle: 'Fel vid köp!',
      errorMessage: 'Vi lyckades av någon anledning inte genomföra köpet av alla lotterna. Därför skickas inget meddelande till mottagaren.\n' + "".concat(numberOfVouchers, " lotter k\xF6ptes. Du hittar dem i Presentlotter i <a href=\"").concat(svs.core.urlMapping.get('myBetsHome'), "\">Mina Spel</a>. ") + "Presentlott-kod kan du anv\xE4nda f\xF6r att l\xF6sa in lott sj\xE4lv eller s\xE5 kan du skicka den sj\xE4lv hur du vill."
    });
  }
}
setGlobal('svs.tur.payment.api.jupiter.vouchers.services.PaymentError', PaymentError);

 })(window);